import SliderSearchInput from './SliderSearchInput';
export default SliderSearchInput;